export default __webpack_public_path__ + "ac93c42dcf8ba4d61628296cd8a6a642.svg";